import { createAction, props } from '@ngrx/store';
import { UserState } from './user.reducer';

export const setUser = createAction(
  '[Session] Set user',
  props<{ user: UserState }>()
);

export const resetUser = createAction('[Session] Reset user');
